var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyInvestor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ECDCF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3496_21509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 25.3337C25 29.0114 27.9889 32.0003 31.6667 32.0003C35.3444 32.0003 38.3333 29.0114 38.3333 25.3337C38.3333 25.0392 38.3056 24.7559 38.2722 24.4725C38.2722 24.4281 38.2611 24.3892 38.25 24.3448C37.7722 21.1392 35.0056 18.667 31.6667 18.667C29.2 18.667 27.0444 20.017 25.8889 22.017C25.8889 22.0281 25.8778 22.0337 25.8722 22.0448C25.3222 23.017 25 24.1337 25 25.3281V25.3337ZM31.6667 30.3337C28.9111 30.3337 26.6667 28.0892 26.6667 25.3337C26.6667 24.7837 26.7611 24.2559 26.9222 23.7614C28.7944 25.3003 31.1667 26.167 33.6056 26.167H33.6111C34.65 26.167 35.6611 26.0114 36.6444 25.717C36.45 28.2948 34.2944 30.3337 31.6611 30.3337H31.6667ZM31.6667 20.3337C33.9667 20.3337 35.9 21.8948 36.4833 24.0114C35.5611 24.3281 34.6 24.5003 33.6111 24.5003C31.45 24.5003 29.3444 23.6837 27.7389 22.2559C28.6556 21.0892 30.0778 20.3337 31.6722 20.3337H31.6667Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1778 33.7451C36.15 33.734 36.1222 33.7229 36.0889 33.7118C34.7222 33.1507 33.2333 32.834 31.6667 32.834C30.1 32.834 28.6056 33.1507 27.2444 33.7118C27.2167 33.7229 27.1833 33.7284 27.1556 33.7451C22.9556 35.5118 20 39.6673 20 44.5007C20 44.9618 20.3722 45.334 20.8333 45.334C21.2944 45.334 21.6667 44.9618 21.6667 44.5007C21.6667 40.8007 23.6944 37.5673 26.6944 35.8395C26.95 38.3618 29.0833 40.334 31.6667 40.334C34.25 40.334 36.3889 38.3618 36.6389 35.8395C39.6389 37.5673 41.6667 40.8007 41.6667 44.5007C41.6667 44.9618 42.0389 45.334 42.5 45.334C42.9611 45.334 43.3333 44.9618 43.3333 44.5007C43.3333 39.6673 40.3778 35.5118 36.1778 33.7451ZM35 35.334C35 37.1729 33.5056 38.6673 31.6667 38.6673C29.8278 38.6673 28.3333 37.1729 28.3333 35.334V35.084C29.3778 34.7118 30.4944 34.5007 31.6667 34.5007C32.8389 34.5007 33.9556 34.7118 35 35.084V35.334Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3496_21509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 26.6667,
    fill: "white",
    transform: "translate(20 18.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyInvestor);
export default __webpack_public_path__ + "static/media/loyalty_investor.71246f26233e2b6287402b0ffa4e3568.svg";
export { ForwardRef as ReactComponent };